import React, { useState, useEffect } from "react";
import Logo from "../../assets/Swalok.png";


const SaleHistory = ({userData}) => {
  const [saleHistory, setSaleHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showInv, setShowInv] = useState(false);
  const [selectedInv, setSelectedInv] = useState('');

  useEffect(() => {
    // Fetch reports only for the logged-in user
    const fetchSaleHistory = async () => {
      try {
        const response = await fetch(
          `https://api.swalokgroup.com/api/get-sale-invoice`
        );
        if (response.status !== 200) {
          throw new Error("Failed to fetch invoices");
        }
        const data = await response.json();
        data.sort(
          (a, b) => new Date(b.invoice_date) - new Date(a.invoice_date)
        );
        setSaleHistory(data);
      } catch (error) {
        console.log(error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchSaleHistory();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };

  return (
    <>
      <section className="py-5">
        <div className="container">
          <div className="sec-subheading">
            <hr />
            <span>Sale History</span>
            <hr />
          </div>

          <div className="table-responsive text-center mt-4">
            <table className="w-100">
              <thead>
                <tr className="bg-light para-text">
                  <th className="py-3 px-2">Inv No</th>
                  <th className="py-3 px-2">Customer Name</th>
                  <th className="py-3 px-2">Agent Id</th>
                  <th className="py-3 px-2">Date</th>
                  <th className="py-3 px-2">Plot Details</th>
                  <th className="py-3 px-2">Category</th>
                  <th className="py-3 px-2">Total</th>
                  <th className="py-3 px-2">Received</th>
                  <th className="py-3 px-2">Activity</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr key="loading-row">
                    <td colSpan="8" className="py-3 px-2">
                      Loading sale...
                    </td>
                  </tr>
                ) : saleHistory.length === 0 ? (
                  <tr key="no-data-row">
                    <td colSpan="8" className="py-3 px-2">
                      No Sale History found.
                    </td>
                  </tr>
                ) : (
                  saleHistory.map((sale, index) => (
                    <tr
                      key={index}
                      className="text-muted para-text text-capitalize"
                    >
                      <td className="py-3 px-2">{sale.id}</td>
                      <td className="py-3 px-2">{sale.cust_name}</td>
                      <td className="py-3 px-2">{sale.agent_name}</td>
                      <td className="py-3 px-2">
                        {formatDate(sale.sale_date)}
                      </td>
                      <td className="py-3 px-2">{`Plot No: ${
                        JSON.parse(sale.plot_details)[1]
                      }, ${JSON.parse(sale.plot_details)[2]}`}</td>
                      <td className="py-3 px-2">{sale.booking_type}</td>
                      <td className="py-3 px-2">₹ {sale.total}</td>
                      <td className="py-3 px-2 text-success">
                        ₹ {sale.received}
                      </td>
                      <td onClick={() => {setShowInv(true); setSelectedInv(sale)}} style={{cursor: 'pointer'}}><i class="fa-solid fa-file-invoice fs-5 text-warning"></i></td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          {/* table ends */}
        </div>


         {showInv && (
        <div
        className="p-3"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflowY: 'scroll',
            zIndex: 1000,
          }}
        >
          <div
            className="bg-white rounded-2 p-3 col-md-10"
          >

            <div className="border p-4" id='print-invoice'>
            <p className="fw-bold fs-4 text-center">Sale Invoice</p>

<div className="row justify-content-between px-3">
  <div className="col-lg-4 p-2 border">
            <img src={Logo} className="sidebar-logo" alt="sidebar logo" /></div>

<div className="col-lg-4 fw-semibold align-content-center border para-text p-3">
Invoice No: {selectedInv.id}<br />
Date: {formatDate(selectedInv.sale_date)}<br />
Customer Name: {selectedInv.cust_name}<br />
Mobile No: {selectedInv.cust_no}
</div>

<div className="col-lg-4 fw-semibold align-content-center border para-text p-3">
    {userData.name}<br />
    Contact: {userData.mobile}<br />
    Address: {userData.address}<br />
</div>

  
</div>
{/* row ends */}


<div className="table-reponsive px-1">
<table className="table w-100">

<thead className="border">
  <th className="p-2">Plot No</th>
  <th className="p-2">Plot Name</th>
  <th className="p-2">Total Sq. Feet</th>
</thead>

<tbody className="border">
  <tr>
    <td className="p-2">{JSON.parse(selectedInv.plot_details)[1]}</td>
    <td className="p-2">{JSON.parse(selectedInv.plot_details)[2]}</td>
    <td className="p-2">{JSON.parse(selectedInv.plot_details)[3]}</td>
  </tr>
</tbody>


</table>
</div>


<div className="d-flex justify-content-between px-2">
<p className="para-text fw-semibold">Type: {selectedInv.booking_type}<br />
Payment Mode: {selectedInv.pay_method}<br />
Remark: {selectedInv.description}</p>


<p className="para-text fw-semibold">Total Amount: {selectedInv.total}<br />
Amount Paid: {selectedInv.received}<br />
<span className="text-danger">Due Amount: {selectedInv.due}</span></p>
</div>


          </div>


                      <div className="mt-4">
              <button
  onClick={() => window.print()}                style={{
                  padding: "8px 15px",
                  marginRight: "10px",
                  background: "blue",
                  color: "#fff",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                className="print-hide"
              >
                Download
              </button>
              <button
              onClick={() => {
                setSelectedInv('');
                setShowInv(false)
              }}
                style={{
                  padding: "8px 15px",
                  background: "#ccc",
                  color: "#000",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                className="print-hide"
              >
                Close
              </button>
            </div>
            {/* btn ends */}
          </div>
        </div>
      )}
      </section>



      
    </>
  );
};

export default SaleHistory;
